/// <reference path="BaseField.ts" />
/// <reference path="SimpleDate.ts" />

namespace MACRAIL.Forms.Fields {

export class SimpleTime extends BaseField {

    protected opts: SimpleTimeOptions;

    private inputForUser: JQuery;

    private defaultAddonHtml: string;

    private relativeTo: SimpleDate | SimpleTime;

    constructor (element: string | JQuery, opts: ObjectHash = {}) {

        opts.allowFuture = opts.allowFuture || 0;

        if (typeof opts.allowFuture === 'string') {
            switch (opts.allowFuture.substr(opts.allowFuture.length - 1)) {
                case 'm':
                    opts.allowFuture = parseInt(opts.allowFuture, 10) * 60000;
                    break;
                case 'h':
                    opts.allowFuture = parseInt(opts.allowFuture, 10) * 3600000;
                    break;
                default:
                    opts.allowFuture = parseInt(opts.allowFuture, 10);
                    break;
            }
        }

        super(element, opts);

        this.inputForUser = this.element.find('input[type="text"]');

        this.defaultAddonHtml = this.element.find('.input-group-addon').html();

        this.element.on('change', () => {
            this.recalculate();
        });

        /*this.element.on('keyup', () => {
            this.recalculate();
        });*/

        setInterval(() => {
            // Don't mess around when the user is still focused there.
            if (this.inputForUser.is(':focus')) {
                return;
            }
            this.recalculate();
        }, 60000);
    }

    public setRelativeTo(relativeTo: SimpleDate | SimpleTime) {
        this.relativeTo = relativeTo;

        $(this.relativeTo.getElement()).on('change', () => {
            this.recalculate();

            // Programattic changes don't get events which means if you have chain of Simple* fields
            // The event won't propagate, so let's force an event here.
            // Hopefully this isn't janky.
            this.element.trigger('change');
        });
    }

    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        if (enabled) {
            this.inputForUser
                .prop('disabled', false)
                .removeClass('disabled');
        } else {
            this.inputForUser
                .prop('disabled', true)
                .addClass('disabled');
        }
    }

    public setValue(newValue: any) {
        // If a Date object was supplied, format as 'hh:mm'.
        if (newValue && newValue.getFullYear) {
            newValue = (newValue.getHours() < 10 ? '0' : '' ) + newValue.getHours() + ':' +
                       (newValue.getMinutes() < 10 ? '0' : '' ) + newValue.getMinutes();
        }

        this.inputForUser.val(newValue);
        this.setDirty(true);
        this.recalculate();
    }

    public recalculate() {
        let val = this.inputForUser.val();

        let $addon = this.element.find('.input-group-addon');

        if (val === '') {
            $addon.html(this.defaultAddonHtml);
            this.value = undefined;
            return false;
        }

        let splitTime = val.match(/^(\d\d)[^\d]?(\d\d)$/);

        if (!splitTime || splitTime.length !== 3 || splitTime[1] > 23 || splitTime[2] > 59) {
            $addon.html('<i class="fa fa-ban" style="color: #994444;"></i>');
            this.value = undefined;
            return false;
        }

        // Matches exactly, let's format nicely.
        if (splitTime.length === 3) {
            val = ('0' + splitTime[1]).substr(-2, 2) + ':' + splitTime[2];
            this.inputForUser.val(val);
        }

        // Create a Date object.
        let dateCalc: Date = undefined;

        let now = (new Date()).getTime();

        if (this.relativeTo instanceof SimpleDate) {
            dateCalc = this.relativeTo.getValue();
            dateCalc.setHours(parseInt(splitTime[1], 10), parseInt(splitTime[2], 10), 0, 0);
        } else if (this.relativeTo instanceof SimpleTime) {
            let otherDate = this.relativeTo.getValue();
            if (otherDate) {
                dateCalc = new Date(otherDate.getTime());
                dateCalc.setHours(parseInt(splitTime[1], 10), parseInt(splitTime[2], 10), 0, 0);
                if (dateCalc.getTime() < otherDate.getTime()) {
                    dateCalc.setDate(dateCalc.getDate() + 1);
                }
            }
        }

        // If no dateField, or the value is undefined.
        if (!dateCalc) {
            dateCalc = new Date();
            dateCalc.setHours(parseInt(splitTime[1], 10), parseInt(splitTime[2], 10), 0, 0);

            // If the time is after the 'allow future' time, then roll back 24 hours.

            let diff2 = dateCalc.getTime() - now;

            if (diff2 > this.opts.allowFuture) {
                dateCalc.setDate(dateCalc.getDate() - 1);
            } else if (diff2 < this.opts.allowFuture - 24 * 3600000) {
                dateCalc.setDate(dateCalc.getDate() + 1);
            }
        }

        let triggerEvent = false;

        if (this.value && this.value.getTime() !== dateCalc.getTime()) {
            triggerEvent = true;
        }

        this.value = dateCalc;

        // Figure out the nice rounded time display.



        let html = this.defaultAddonHtml;

        let diffInDays = (now - dateCalc.getTime()) / 86400000;

        if (diffInDays < 60) {
            html = '<small>' + MACRAIL.Helpers.formatRelativeTime(dateCalc) + '</small>';
        }

        $addon.html(html);

        if (triggerEvent) {
            this.element.trigger('fieldchanged');
        }

        return true;
    }
}

interface SimpleTimeOptions extends FieldOptions {
    allowFuture: number;
}

}
